/* eslint-disable no-case-declarations */
import {
  useState, useEffect, useRef, useContext,
} from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import Button from '../../../juristec-ui/core/Button';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import IconButton from '../../../juristec-ui/core/IconButton';
import Select2 from '../../../juristec-ui/core/SelectNew';
import Select from '../../../juristec-ui/core/Select';

import {
  Close, UploadImage,
} from '../../../juristec-ui/icons';

import {
  CreateReportContainer,
  FormLine,
  InputWrapper,
  ImageOverlay,
  ImageContainer,
  CardContainer,
  CardHeader,
  CardMain,
  BackgroundOptions,
  CheckboxInputWrapper,
  TabGroup,
  TabButton,
  StyledContentTab,
  ModifiersContainer,
  LabelSmall,
} from './styled/ExtractReport.styled';
import Checkbox from '../../../juristec-ui/core/Checkbox';
import SelectTips from '../../Popovers/SelectTips';
import KpiFilter from '../../KpiFilter';
import KpiFilterApplied from '../../KpiFilterApplied';
import { AlertContext } from '../../../context/AlertProvider';
import {
  dateOptions,
  filterTypeOptionsSimple,
  filterTypeOptionsDate,
  filterTypeOptionsNumber,
  filterTypeOptionsText,
} from '../../../options';
import uuidv4 from '../../../juristec-ui/utils/functions/randomUUID';
import { error } from '../../../label';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';
import { verifyFileName } from '../../../juristec-ui/utils/validators/inputTextValidators';

const generateReportDefaultPropFiles = [];
const generateReportDefaultPropTourContext = { tourOpen: false, nextStep: () => {}, remakeTourList: () => {} };
const generateReportDefaultPropClose = () => {};
const generateReportDefaultPropCheckImage = () => {};
const generateReportDefaultPropGenerateReport = () => {};

/**
* A component to inform the attributes of a new dashboard
*/
const GenerateReport = ({
  files = generateReportDefaultPropFiles,
  getColumns,
  fetchFileSampleData,
  getUnique,
  close = generateReportDefaultPropClose,
  tourContext = generateReportDefaultPropTourContext,
  checkImage = generateReportDefaultPropCheckImage,
  generateReport = generateReportDefaultPropGenerateReport,
}) => {
  const { setAlertConfig } = useContext(AlertContext);
  const [tab, setTab] = useState('general');
  const [selectedFile, setSelectedFiles] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [includeImg, setIncludeImg] = useState(true);
  const [includeDate, setIncludeDate] = useState(true);
  const [reportImage, setReportImage] = useState('');
  const [outputFormat, setOutputFormat] = useState({ label: 'Excel', value: 'xlsx', id: 'xlsx' });
  // const [imgFile, setImgFile] = useState(null);
  const [filterConfig, setFilterConfig] = useState({
    column: undefined,
    selector: undefined,
    type: { label: 'Simples', value: 'simple', id: 'simple' },
    format: { value: 'values', label: 'Por valores', id: 'values' },
    values: [],
  });
  const [dataFrame, setDataFrame] = useState(null);
  const [dataFrameOptions, setDataFrameOptions] = useState([]);
  const [filterValuesOptions, setFilterValuesOptions] = useState([]);
  const [filtersToSend, setFiltersToSend] = useState([]);
  const [generateBtnDisabled, setGenerateBtnDisabled] = useState(true);
  const [extractedReportFilename, setExtractedReportFilename] = useState({
    value: '', errorMsg: 'O nome do arquivo não pode estar vazio!', error: true,
  });
  const [imageBlob, setImageBlob] = useState(null);
  const wrapperRef = useRef(null);
  const inputFile = useRef(null);

  const handleName = (value) => {
    const val = value.split(' ').filter((v) => v).join('');
    const msg = verifyFileName(val);
    setExtractedReportFilename({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const handleSubmit = async () => {
    await generateReport(
      selectedFile.id,
      outputFormat.value,
      reportImage !== '' ? imageBlob : null,
      filtersToSend ? { filters: filtersToSend } : filtersToSend,
      includeDate,
      selectedColumns.map((c) => c.value),
      extractedReportFilename.value,
    );
  };

  // const handleImgPick = (url) => {
  //   setImgFile(url);
  //   setReportImage(url);
  //   setColors((p) => ({ ...p, mainColor: '' }));
  // };

  // Update handleUpload to store both the blob and preview URL
  const handleUpload = (e) => {
    URL.revokeObjectURL(reportImage);
    const file = e.target.files[0];
    if (file && checkImage(file)) {
      setImageBlob(file); // Store the actual file/blob
      setReportImage(URL.createObjectURL(file)); // Store URL for preview
      if (tourContext.tourOpen) tourContext.nextStep();
    }
  };

  const removeImg = () => {
    URL.revokeObjectURL(reportImage);
    setReportImage('');
    setImageBlob(null);
  };

  // Update cleanup useEffect
  useEffect(() => () => {
    URL.revokeObjectURL(reportImage);
  }, []);

  useEffect(() => {
    if (selectedFile?.id) {
      setGenerateBtnDisabled(false);
    }
  }, [selectedFile]);
  useEffect(() => {
    if (!includeImg) {
      removeImg();
    }
  }, [includeImg]);

  useEffect(() => {
    const getUniqueBySelected = (selected, sFormat) => {
      if (selected) {
        // handleFilterConfig('sFormat',{value: 'values',label:'Filtro por valores',id: 'values'});
        if (dataFrame.types[selected.value] !== 'datetime64[ns]') {
          return getUnique(selectedFile.id, selected.value, '');
        } if (sFormat) {
          return getUnique(selectedFile.id, selected.value, sFormat.value);
        }
      }
      return [];
    };
    (async () => {
      if (filterConfig.column) {
        setFilterValuesOptions(
          await getUniqueBySelected(filterConfig.column, filterConfig.selector),
        );
      }
    })();
  }, [filterConfig.column, filterConfig.selector]);

  const fetchAndSetFileSampleData = async (page = 0, stateSort = { field: 'index', order: 0 }, pageSize = 20, fileId) => {
    const {
      error: er, msg, raw, tempArray, newDT,
    } = await fetchFileSampleData(page, stateSort, pageSize, fileId);
    if (er) {
      // goBack();
      setAlertConfig({
        type: 'error',
        text: msg,
        child: raw,
      });
      // goBack();
    } else {
      // setfileLength((res.total_pages - 1) * pageSize);
      setDataFrameOptions(tempArray);
      // setDataFrameDescription(res.description);
      setDataFrame(newDT);
    }
  };

  const handleSelectedFiles = async (selected) => {
    setSelectedFiles(selected);
    const columns = await getColumns(selected.id);
    await fetchAndSetFileSampleData(0, { field: 'index', order: 0 }, 20, selected.id); //
    setFileColumns(columns);
    setSelectedColumns([]);
  };

  const handleConfigModifiers = (key, val, state, setState) => {
    const newConfig = { ...state };
    switch (key) {
      case 'type':
        newConfig.type = val;
        newConfig.selector = null;
        newConfig.values = [];
        if (val.value === 'simple') {
          newConfig.format = { value: 'values', label: 'Por valores', id: 'values' };
        } else {
          newConfig.format = { value: '', label: '', id: '' };
        }
        break;
      case 'format':
        newConfig.format = val;
        switch (val.value) {
          case 'not-contains':
          case 'contains':
          case 'not-values':
          case 'values':
            newConfig.values = [];
            break;
          case 'specific_date':
            newConfig.values = [{ value: 'hoje', label: 'Hoje', id: 'today' }];
            break;
          case 'not-between':
          case 'between':
          case 'not-between_inc':
          case 'between_inc':
            if (dataFrame.Types[state.column.value] === 'datetime64[ns]') {
              newConfig.values = [new Date(), new Date()];
            } else {
              newConfig.values = ['', ''];
            }
            break;
          case 'not-before':
          case 'before':
          case 'not-before_inc':
          case 'before_inc':
          case 'not-after':
          case 'after':
          case 'not-after_inc':
          case 'after_inc':
            newConfig.values = [new Date()];
            break;
          default:
            newConfig.values = [''];
            break;
        }
        break;
      case 'column':
        newConfig.column = val;
        if (newConfig.type.value === 'simple') {
          newConfig.format = { value: 'values', label: 'Por valores', id: 'values' };
        } else {
          newConfig.format = { value: '', label: '', id: '' };
        }
        break;
      default:
        newConfig[key] = val;
        break;
    }
    setState(newConfig);
  };

  const handleFilterConfig = (key, val) => {
    handleConfigModifiers(key, val, filterConfig, setFilterConfig);
  };

  const getTypeOptions = (isSimple, columnType) => {
    if (isSimple) {
      return filterTypeOptionsSimple;
    }
    switch (columnType) {
      case 'datetime64[ns]':
        // if (isGroup) return groupTypeOptionsDate;
        return filterTypeOptionsDate;
      case 'float64':
        return filterTypeOptionsNumber;
      default:
        return filterTypeOptionsText;
    }
  };

  const handleFilterModifiers = (selected, state, setState, valueOptions) => {
    const regexFloat = /^-{0,1}\d*\.{0,1}\d*/;
    const regexInt = /^\d*/;
    switch (state.format.value) {
      case 'not-values':
      case 'values':
        if (!selected) setState('values', []); // qnd limpa tudo
        else if (selected.length === 0) setState('values', []);
        else if (selected[0].value === 'select_all') setState('values', valueOptions);
        else if (selected.length > 0) setState('values', selected);
        break;
      case 'not-contains':
      case 'contains':
        const auxVals = new Set(state.values);
        auxVals[selected.operation](selected.val);
        setState('values', [...auxVals]);
        break;
      case 'not-between':
      case 'between':
      case 'not-between_inc':
      case 'between_inc':
        let val1 = selected.start;
        let val2 = selected.end;
        if (dataFrame.types[state.column.value] !== 'datetime64[ns]') {
          [val1] = selected.start?.toString()?.replace(',', '.')?.match(regexFloat) || '';
          [val2] = selected.end?.toString()?.replace(',', '.')?.match(regexFloat) || '';
        }
        setState('values', [
          val1 || (val1 !== '' ? state.values[0] : ''), val2 || (val2 !== '' ? state.values[1] : ''),
        ]);
        break;
      case 'not-before':
      case 'before':
      case 'not-before_inc':
      case 'before_inc':
      case 'not-after':
      case 'after':
      case 'not-after_inc':
      case 'after_inc':
        setState('values', [selected]);
        break;
      case 'not-greater':
      case 'greater':
      case 'not-lesser':
      case 'lesser':
      case 'not-greater_inc':
      case 'greater_inc':
      case 'not-lesser_inc':
      case 'lesser_inc':
        const [valF] = selected.toString().replace(',', '.').match(regexFloat);
        setState('values', [valF || '']);
        break;
      case 'specific_date':
        setState('values', [selected]);
        break;
      case 'current_month':
      case 'current_year':
      case 'current_semester':
      case 'current_quarter':
      case 'current_week':
        setState('values', []);
        break;
      default:
        const [val] = selected.toString().match(regexInt);
        setState('values', [val || '']);
        break;
    }
  };

  const handleFilterChange = (selected) => {
    handleFilterModifiers(selected, filterConfig, handleFilterConfig, filterValuesOptions);
  };

  const checkValsModifiers = (modifierObj) => {
    switch (modifierObj.format.value) {
      case 'not-contains':
      case 'contains':
      case 'not-values':
      case 'values':
      case 'specific_date':
        return modifierObj.values.length > 0;
      case 'not-between':
      case 'between':
      case 'not-between_inc':
      case 'between_inc':
        let val1 = modifierObj.values[0];
        let val2 = modifierObj.values[1];
        if (dataFrame.types[modifierObj.column.value] !== 'datetime64[ns]') {
          if (val1?.length > 0 && val2?.length > 0) {
            val1 = Number(modifierObj.values[0]);
            val2 = Number(modifierObj.values[1]);
          } else {
            return false;
          }
        }
        return !Number.isNaN(val1) && !Number.isNaN(val2) && val2 > val1;
      case 'not-before':
      case 'before':
      case 'not-before_inc':
      case 'before_inc':
      case 'not-after':
      case 'after':
      case 'not-after_inc':
      case 'after_inc':
        return modifierObj.values[0] instanceof Date;
      case 'current_month':
      case 'current_year':
      case 'current_semester':
      case 'current_quarter':
      case 'current_week':
        return true;
      default:
        if (modifierObj.values[0]?.length > 0) {
          const val = Number(modifierObj.values[0]);
          return !Number.isNaN(val);
        }
        return false;
    }
  };

  const getSelectorByType = (ftype) => {
    switch (ftype) {
      case 'lastY':
      case 'not-lastY':
      case 'nextY':
      case 'not-nextY':
      case 'previousY':
      case 'not-previousY':
      case 'current_and_previousY':
      case 'not-current_and_previousY':
      case 'followingY':
      case 'not-followingY':
      case 'current_and_followingY':
      case 'not-current_and_followingY':
        return 'year';
      case 'lastM':
      case 'not-lastM':
      case 'nextM':
      case 'not-nextM':
      case 'previousM':
      case 'not-previousM':
      case 'current_and_previousM':
      case 'not-current_and_previousM':
      case 'followingM':
      case 'not-followingM':
      case 'current_and_followingM':
      case 'not-current_and_followingM':
        return 'M';
      case 'lastD':
      case 'not-lastD':
      case 'nextD':
      case 'not-nextD':
      case 'previousD':
      case 'not-previousD':
      case 'current_and_previousD':
      case 'not-current_and_previousD':
      case 'followingD':
      case 'not-followingD':
      case 'current_and_followingD':
      case 'not-current_and_followingD':
        return 'D';
      case 'lastQ':
      case 'not-lastQ':
      case 'nextQ':
      case 'not-nextQ':
      case 'previousQ':
      case 'not-previousQ':
      case 'current_and_previousQ':
      case 'not-current_and_previousQ':
      case 'followingQ':
      case 'not-followingQ':
      case 'current_and_followingQ':
      case 'not-current_and_followingQ':
        return 'Q';
      case 'lastW':
      case 'not-lastW':
      case 'nextW':
      case 'not-nextW':
      case 'previousW':
      case 'not-previousW':
      case 'current_and_previousW':
      case 'not-current_and_previousW':
      case 'followingW':
      case 'not-followingW':
      case 'current_and_followingW':
      case 'not-current_and_followingW':
        return 'W';
      case 'lastS':
      case 'not-lastS':
      case 'nextS':
      case 'not-nextS':
      case 'previousS':
      case 'not-previousS':
      case 'current_and_previousS':
      case 'not-current_and_previousS':
      case 'followingS':
      case 'not-followingS':
      case 'current_and_followingS':
      case 'not-current_and_followingS':
        return 'semester';
      default:
        return '';
    }
  };

  const getActualTypeAndInverse = (ftype) => {
    const ftypeInfo = ftype.split('-');
    let actualFtype = ftypeInfo?.[1] || ftypeInfo?.[0];
    if (['lastY', 'lastM', 'lastD', 'lastQ', 'lastW', 'lastS'].includes(actualFtype)) {
      actualFtype = 'last';
    } else if (['nextY', 'nextM', 'nextD', 'nextQ', 'nextW', 'nextS'].includes(actualFtype)) {
      actualFtype = 'next';
    } else if (['previousY', 'previousM', 'previousD', 'previousQ', 'previousW', 'previousS'].includes(actualFtype)) {
      actualFtype = 'previous';
    } else if (['followingY', 'followingM', 'followingD', 'followingQ', 'followingW', 'followingS'].includes(actualFtype)) {
      actualFtype = 'following';
    } else if (['current_and_previousY', 'current_and_previousM', 'current_and_previousD', 'current_and_previousQ', 'current_and_previousW', 'current_and_previousS'].includes(actualFtype)) {
      actualFtype = 'current_and_previous';
    } else if (['current_and_followingY', 'current_and_followingM', 'current_and_followingD', 'current_and_followingQ', 'current_and_followingW', 'current_and_followingS'].includes(actualFtype)) {
      actualFtype = 'current_and_following';
    }
    return [
        ftypeInfo?.[0] === 'not',
        actualFtype,
    ];
  };

  const formatValue = (value, mFormat, isDate, isSimple) => {
    if (isSimple || mFormat === 'specific_date') {
      if (value === 'select_all') return null;
      return value.value;
    }
    if (isDate && [
      'between', 'between_inc', 'before', 'before_inc', 'after', 'after_inc',
    ].includes(mFormat)) {
      return format(value, 'yyyy-MM-dd');
    }
    if (mFormat !== 'contains') {
      return Number(value);
    }
    return value;
  };

  const addFilter = () => {
    if (filterConfig.column && checkValsModifiers(filterConfig)) {
      const columnType = dataFrame.types[filterConfig.column.value];
      const [isInverse, actualType] = getActualTypeAndInverse(filterConfig.format.value);
      const isSimple = filterConfig.type.value === 'simple';

      const fObjAux = {
        uid: uuidv4(),
        column: filterConfig.column.value,
        type: columnType,
        ftype: actualType || 'values',
        selector: isSimple ? (filterConfig?.selector?.value || '') : getSelectorByType(filterConfig.format.value),
        values: filterConfig.values.reduce((aux, v) => {
          const val = formatValue(v, actualType, columnType === 'datetime64[ns]', isSimple);
          if (val || val === 0) aux.push(val);
          return aux;
        }, []),
        inverse: isInverse,
      };
      const nfilters = [...filtersToSend].concat([fObjAux]);
      // console.log(fObjAux);
      setFiltersToSend(nfilters);
      setFilterConfig({
        column: null,
        selector: null,
        type: { label: 'Simples', value: 'simple', id: 'simple' },
        format: { value: 'values', label: 'Por valores', id: 'values' },
        values: [],
      });
      setGenerateBtnDisabled(false);
    } else {
      setAlertConfig({ type: 'error', text: error.generic, child: 'Filtro ainda não foi especificado' });
    }
  };

  const removeFilterHandle = (filterUid) => {
    setAlertConfig({
      type: 'warning',
      child: 'Deseja mesmo remover esse filtro?',
      text: 'Tem certeza?',
      withFunction: true,
      withoutConfirm: true,
      confirmFunction: () => {
        setFiltersToSend(filtersToSend.filter((item) => item.uid !== filterUid));
        setGenerateBtnDisabled(false);
      },
    });
  };

  const editFilterHandle = (filterUid, filterColumn, newValues, ftype) => {
    if (newValues.length === 0) return;
    setFiltersToSend(filtersToSend.map((item) => (
      item.uid === filterUid ? {
        ...item,
        values: newValues.map((v) => (
          formatValue(v, ftype, dataFrame.types[filterColumn] === 'datetime64[ns]', ftype === 'values')
        )),
      } : item
    )));
    setGenerateBtnDisabled(false);
  };

  const changeOrderModifiers = (pos, varOp, state, setState) => {
    const newPos = pos + varOp;
    if (newPos < 0 && newPos >= state.length) return;
    const tempList = [...state];
    const [auxItem] = tempList.splice(pos, 1);
    tempList.splice(newPos, 0, auxItem);
    setState(tempList);
    setGenerateBtnDisabled(false);
  };

  const changeFilterOrder = (pos, varOp) => {
    changeOrderModifiers(pos, varOp, filtersToSend, setFiltersToSend);
  };

  return (
    <>
      <TabGroup>
        <TabButton active={tab === 'general'} onClick={() => setTab('general')}>
          <span>Geral</span>
        </TabButton>
        <TabButton
          active={tab === 'filter'}
          onClick={() => setTab('filter')}
          title="Selecione os Filtros para o seu relatório"
          disabled={selectedFile.length === 0}
        >
          <span>Filtros</span>
        </TabButton>
      </TabGroup>
      <CreateReportContainer>
        {tab === 'general' && (
          <>
            <FormLine>
              <InputWrapper>
                <Select2
                  options={files.map((f) => (
                    {
                      value: f.filename, label: f.filename, id: f.file_id, ...f,
                    }
                  ))}
                  onChange={handleSelectedFiles}
                  value={selectedFile}
                  atModal
                  searchable
                  sortBy="ascending"
                  label="Selecione o arquivo"
                />
              </InputWrapper>
            </FormLine>
            <FormLine>
              <InputWrapper>
                <Select2
                  options={fileColumns}
                  onChange={setSelectedColumns}
                  value={selectedColumns}
                  atModal
                  searchable
                  label="Selecione as colunas"
                  multiple
                  sortBy="ascending"
                  stayOpen
                  selectAll
                />
              </InputWrapper>
            </FormLine>
            <FormLine style={{ marginTop: '10px' }}>
              <CheckboxInputWrapper>
                <Checkbox
                  text="Adicionar imagem no relatório"
                  color="primary"
                  variant="outlined"
                  checked={includeImg}
                  handleCheckboxChange={() => setIncludeImg(!includeImg)}
                />
              </CheckboxInputWrapper>
            </FormLine>
            {includeImg && (
              <FormLine style={{ marginTop: '10px' }}>
                <input
                  type="file"
                  ref={inputFile}
                  accept="image/*"
                  onChange={handleUpload}
                  style={{ display: 'none' }}
                />
                <CardContainer
                  bgColor="#C9C9C9"
                  bgSrc={reportImage}
                  className="pickImage"
                  stopAnimation
                  ref={wrapperRef}
                  includeImg
                >
                  <CardHeader bgColor="transparent">
                    {/* <h5>
                      {dashboardGroup.label?.length > 0 ? dashboardGroup.label : 'Sem Grupo'}
                    </h5> */}
                  </CardHeader>
                  <CardMain bgColor="#C9C9C9">
                    <ImageContainer>
                      <ImageOverlay>
                        <BackgroundOptions>
                          <Tooltip text="Adicionar nova imagem" direction="left" atModal>
                            <IconButton
                              onClick={() => inputFile.current.click()}
                              color="white"
                              size="medium"
                              className="image_trigger"
                            >
                              <UploadImage />
                            </IconButton>
                          </Tooltip>
                          {reportImage.length > 0 && (
                            <Tooltip text="Remover imagem atual" direction="right" atModal>
                              <IconButton
                                onClick={removeImg}
                                color="white"
                                size="medium"
                                className="fix-icon"
                              >
                                <Close />
                              </IconButton>
                            </Tooltip>
                          )}
                        </BackgroundOptions>
                      </ImageOverlay>
                    </ImageContainer>
                  </CardMain>
                </CardContainer>
              </FormLine>
            )}
            <FormLine style={{ marginTop: '10px' }}>
              <CheckboxInputWrapper>
                <Checkbox
                  text="Adicionar data de criação no relatório"
                  color="primary"
                  variant="outlined"
                  checked={includeDate}
                  handleCheckboxChange={() => setIncludeDate(!includeDate)}
                />
              </CheckboxInputWrapper>
            </FormLine>
            <FormLine style={{ marginTop: '10px' }}>
              <Select
                selectLabel="Formato de saída"
                atModal
                placeholder="Selecione"
                onChange={(newValue) => setOutputFormat(newValue)}
                value={outputFormat}
                options={[
                  { label: 'Excel', value: 'xlsx', id: 'xlsx' },
                  { label: 'Pdf', value: 'pdf', id: 'pdf' },
                  { label: 'Documento do Word', value: 'docx', id: 'docx' },
                ]}
                fullWidth
              />
            </FormLine>
            <FormLine>
              <InputTextLine
                label="Nome do relatório *"
                value={extractedReportFilename.value}
                placeholder="Digite o nome"
                errorMessage={extractedReportFilename.errorMsg}
                error={extractedReportFilename.errorMsg.length > 0}
                onChange={(e) => handleName(e.target.value)}
              />
            </FormLine>
          </>
        )}
        {tab === 'filter' && (
          <StyledContentTab className="kpi-side-content-tab">
            <div className="gap-fix-first">
              <div className="gap-fix-second">
                <div style={{ width: '50%' }}>
                  <Select
                    alphabeticalOrder
                    isSearchable
                    selectLabel="Filtrar por"
                    placeholder="Selecione"
                    atModal
                    onChange={(newValue) => handleFilterConfig('column', newValue)}
                    value={filterConfig.column || ({
                      label: filterConfig.column,
                      value: filterConfig.column,
                      id: filterConfig.column,
                    })}
                    options={dataFrameOptions}
                    isClearable
                    fullWidth
                    style={{ minWidth: '50%' }}
                  />
                </div>
                <div style={{ width: '50%' }}>
                  <Select
                    selectLabel="Tipo"
                    atModal
                    placeholder="Selecione"
                    onChange={(newValue) => handleFilterConfig('type', newValue)}
                    value={filterConfig.type}
                    options={[
                      { label: 'Simples', value: 'simple', id: 'simple' },
                      { label: 'Avançado', value: 'advanced', id: 'advanced' },
                    ]}
                    formatOptionLabel={false}
                    fullWidth
                    style={{ minWidth: '50%' }}
                  />
                </div>
              </div>
              <div className="gap-fix-second">
                {filterConfig.column
                  && filterConfig.type.value === 'simple'
                  && dataFrame.types[filterConfig.column.value] === 'datetime64[ns]'
                  && (
                    <div style={{ width: '100%' }}>
                      <Select
                        isSearchable
                        atModal
                        selectLabel="Formato"
                        placeholder="Selecione"
                        onChange={(newValue) => handleFilterConfig('selector', newValue)}
                        value={filterConfig.selector}
                        options={dateOptions}
                        formatOptionLabel={false}
                        fullWidth
                        style={{ minWidth: '50%' }}
                      />
                    </div>
                  )}
                {filterConfig.column && (
                  <div style={{ position: 'relative', width: '100%' }}>
                    <Select
                      isSearchable
                      atModal
                      selectLabel="Condição"
                      onChange={(newValue) => handleFilterConfig('format', newValue)}
                      value={filterConfig.format}
                      options={
                        getTypeOptions(filterConfig.type.value === 'simple', dataFrame.types[filterConfig.column.value])
                      }
                      menuPlacement="auto"
                      placeholder="Selecione"
                      // maxMenuHeight={150}
                      menuPosition="fixed"
                      formatOptionLabel={false}
                      // alphabeticalOrder
                      closeMenuOnSelect={false}
                      fullWidth
                    />
                    {filterConfig.format.value !== '' && (
                      <SelectTips
                        description={filterConfig.format.description}
                        style={{ top: '-5px', right: '2px', zIndex: 1050 }}
                      />
                    )}
                  </div>
                )}
              </div>
              {filterConfig.column && filterConfig.format.value !== '' && (filterConfig.type?.value === 'advanced' || filterValuesOptions?.length > 0) && (
                <>
                  <KpiFilter
                    filterType={filterConfig.format.value}
                    handle={handleFilterChange}
                    values={filterConfig.values}
                    options={filterValuesOptions}
                    format={dataFrame.types[filterConfig.column.value]}
                  />
                  <Button
                    onClick={addFilter}
                    color="secondary"
                    disabled={!checkValsModifiers(filterConfig)}
                    style={{ margin: '10px 0 10px', width: '100%' }}
                  >
                    Adicionar filtro
                  </Button>
                </>
              )}
            </div>
            {filtersToSend.length > 0 && (
              <ModifiersContainer>
                <LabelSmall>Filtros Aplicados</LabelSmall>
                {filtersToSend.map((filter, i) => (
                  <KpiFilterApplied
                    key={filter.uid}
                    modifier={filter}
                    removeFunc={removeFilterHandle}
                    editFunc={editFilterHandle}
                    getOptions={() => getUnique(selectedFile.id, filter.column, filter.selector)}
                    dataFrameTypes={dataFrame.types}
                    position={i}
                    isLast={filtersToSend.length - 1 === i}
                    changePosition={changeFilterOrder}
                  />
                ))}
              </ModifiersContainer>
            )}
          </StyledContentTab>
        )}
      </CreateReportContainer>

      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          disabled={extractedReportFilename.errorMsg.length > 0 || generateBtnDisabled}
          size="large"
        >
          Gerar
        </Button>
      </ActionsGroup>

    </>
  );
};

GenerateReport.propTypes = {
  /**
    * Array with the names of the current groups
    */
  files: PropTypes.arrayOf(),
  /**
    * Function to get file columns
    */
  getColumns: PropTypes.func.isRequired,
  /**
    * Function to get info from file
    */
  fetchFileSampleData: PropTypes.func.isRequired,
  /**
    * Function to get unique values from column
    */
  getUnique: PropTypes.func.isRequired,
  /**
   * Function to close the modal or toggle the component visibility
   */
  close: PropTypes.func,

  tourContext: PropTypes.shape({
    tourOpen: PropTypes.bool,
    nextStep: PropTypes.func,
    remakeTourList: PropTypes.func,
  }),
  /**
  *  Function to check if an image satisfies the desired conditions
  */
  checkImage: PropTypes.func,
  /**
   * Function to generate the report
   */
  generateReport: PropTypes.func,
};

export default GenerateReport;
